//#region [IMPORT]

// === THIRD-PARTY ===
import React, { } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { CardHeader, CardContent, Box } from '@mui/material';

// === COMPONENTS ===
import { Thumbnail } from './components/Thumbnail/Thumbnail.jsx';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext.jsx';

//#endregion

export function ThumbPanel() {

  //#region [Main] store

  const theme = useTheme();

  const { task } = useAnalytics();

  const _styles = {
    thumb_paper: {
      gridColumn: 'span 2',
      overflow : 'auto'     ,
      position : 'relative' ,
      height   : '100%',
      width    : '100%',
      boxShadow: 0,
      backgroundColor: theme.palette.panel.main,
    },
    header: {
      boxShadow: '-0.5em 0 0 0.01em' + theme.palette.primary.main,
      padding: '1rem',
      marginBottom: '0.5em',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      height: '4rem',
      zIndex: 5,
    },
    pages: {
      margin : 0,
      justifyContent: 'start',
    },
    document: {
      borderTop       : `5px solid ${theme.palette.primary.main}`,
      borderRadius    : 0,
      boxShadow       : 'none',
      paddingBottom   : theme.spacing(2),
      '&:last-child'  : {
        paddingBottom: theme.spacing(4),
      },
    },
    container: {
      boxShadow: '2',
      width: '100%',
      margin: 0,
      paddingTop : '6px',
      backgroundColor: theme.palette.background.secondary[theme.palette.mode], 
    },
    document_container: {
      height: '100%', width: '100%', overflow: 'auto',

      scrollbarWidth: "none", // Hide the scrollbar for firefox
      '&::-webkit-scrollbar': {
          display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
      },
      '&-ms-overflow-style:': {
          display: 'none', // Hide the scrollbar for IE
      },
    }
  }

  //#endregion

  //-----------------------------------------------------------------
  function displayHeader( title ) {
    //-----------------------------------------------------------------
    return (
      <CardHeader sx={_styles.header} title={title} />
    );
  }

  //-----------------------------------------------------------------
  function displayPages(doc_id) {
    //-----------------------------------------------------------------
    const doc = task.documents.items[doc_id];
    const thumbs = doc.order.map( id => <Thumbnail key={id} id={id} image={task.images.items[id]} /> );

    return (
      <CardContent sx={_styles.pages}>
        {thumbs}
      </CardContent>
    );
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const result = [];
    for (let id of task.documents.order) {
      const doc = task.documents.items[id];
      result.push(
        <Box key={id} sx={_styles.container}>
          { displayHeader( doc.name ) }
          <Box sx={{height: '100%'}}>
            { displayPages ( id ) }
          </Box>
        </Box>
      );
    }
    return (    
      <Box sx={_styles.thumb_paper}>
        <Box sx={_styles.document_container}>
          {result}
        </Box>
      </Box>
    )
  }

  return display();
}
